<template>
  <div v-container>
    <v-tabs v-model="tab" align-with-title>
      <v-tabs-slider color="success"></v-tabs-slider>

      <v-tab v-for="(item, index) in tabs" :key="index"> {{ item.text }} </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(item, index) in tabs" :key="index">
        <v-card flat>
          <v-card-title></v-card-title>
          <v-card-text
            ><content-app v-bind:code="item.value" :name="item.text"></content-app
          ></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import Contents from "./contents";
export default {
  name: "Content-Tabs",
  components: { "content-app": Contents },
  data() {
    return {
      tab: "",
      tabs: [
        { text: "เงื่อนไขและกติกา", value: "Terms" },
        { text: "การชำระเงิน", value: "Payment" },
      ],
    };
  },
  mounted() {
    console.log(this.tabs);
  },
};
</script>
